import React, { useState } from 'react'
import AdminLayout from '../../AdminLayout'
import ContentHeader from '../../layout/ContentHeader'
import CompanyNav from './CompanyNav';
import CompanyProfile from './CompanyProfile';
import CompanyBank from './CompanyBank';
import CompanyLogo from './CompanyLogo';

export default function Company() {

     const [activeTab, setActiveTab] = useState('profile');

     const handleTabChange = (tab) => {
          setActiveTab(tab);
     };
     const renderContent = () => {
          switch (activeTab) {
               case 'profile':
                    return <CompanyProfile />;
               case 'bank':
                    return <CompanyBank />;
               case 'logo':
                    return <CompanyLogo />;
               default:
                    return null;
          }
     };

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="company_details" />

                    <div className="col-lg-12 mb-2">
                         <CompanyNav onTabChange={handleTabChange} />
                    </div>
                    <div className="col-lg-12 ">
                         <div>{renderContent()}</div>
                    </div>
               </div>
          </AdminLayout>
     )
}
